import { cloneElement, ReactElement } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { useTooltip, TooltipPopup, TooltipProps } from '@reach/tooltip'

import styles from './Tooltip.module.css'

const AnimatedTooltip = motion.custom(TooltipPopup)

const tooltipVariants = {
  hidden: {
    opacity: 0,
    y: -10
  },
  visible: {
    opacity: 1,
    y: 0
  }
}

function centered(triggerRect: ClientRect, tooltipRect: ClientRect) {
  const triggerCenter = triggerRect.left + triggerRect.width / 2
  const left = triggerCenter - tooltipRect.width / 2
  const maxLeft = window.innerWidth - tooltipRect.width - 2

  return {
    left: Math.min(Math.max(2, left), maxLeft) + window.scrollX,
    top: triggerRect.bottom + 8 + window.scrollY
  }
}

export function Tooltip({ children, ...rest }: TooltipProps) {
  const [trigger, tooltip, isVisible] = useTooltip()

  return (
    <>
      {cloneElement(children as ReactElement, trigger)}
      <AnimatePresence>
        {isVisible && (
          <AnimatedTooltip
            {...tooltip}
            position={centered}
            variants={tooltipVariants}
            initial="hidden"
            animate="visible"
            exit="hidden"
            className={styles.tooltip + ' z-50'}
            {...rest}
          />
        )}
      </AnimatePresence>
    </>
  )
}
